export default __webpack_public_path__ + "static/media/MAIL-CASATE2022.1e194750.jpg";